import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import React from 'react';
import NotFound from '../../pages/NotFound';

/**
 * Route guard that validates the lang parameter in the route
 */
const LangGuard = (): JSX.Element => {
  const { i18n } = useTranslation();
  const { lang } = useParams();

  if (lang && i18n.languages.includes(lang)) {
    return <Outlet />;
  }

  return <NotFound />;
};

export default LangGuard;
